import React from "react";
import { Controller, useFormState } from "react-hook-form";
import FormErrorMessage from "./FormErrorMessage";

// Without fieldset/legend: Screen readers announce each checkbox individually without context
// With fieldset/legend: Screen readers announce "Group Name, checkbox 1 of N"


const FormCheckboxGroup = ({
  name,
  label,
  labelHelp,
  labelClassName = '',
  wrapperClassName='',
  control,
  options,
  trigger,
  required = false,
  disabled = false,
  readOnly = false,
  rowPosition = false // false, true, first, last
}) => {
  const { errors } = useFormState({ control });

  return (
    <fieldset className={`form-field ${wrapperClassName}`}>
      <legend htmlFor={name} className={`form-label align-left ${labelClassName}`} aria-required={required} style={{ width: '100%' }}>
        {required && (
          <span className="form-layout-required" aria-label="required">
            *
          </span>
        )}
        {label}
        {labelHelp && <span className="font-italic ml-1">{labelHelp}</span>}
      </legend>
      <div>
        {options.map((option) => (
          <div key={`${name}-${option.value}`} className="form-check mb-0 color-black">
            <Controller
              name={name}
              control={control}
              render={({ field }) => {
                const currentValue = Array.isArray(field.value) ? field.value : (field?.value?.split(",") || []);
                return <input
                  type="checkbox"
                  className="form-check-input"
                  disabled={disabled}
                  readOnly={readOnly}
                  id={`${name}-${option.value}`}
                  data-testid={`${name}-${option.value}-checkbox`}
                  value={option.value}
                  checked={currentValue?.includes(option.value)}
                  onChange={(e) => {
                    const updatedList = e.target.checked
                      ? [...currentValue, option.value]
                      : currentValue.filter((item) => item !== option.value);
                    field.onChange(updatedList);
                    if (trigger) {
                      trigger(name);
                    }
                  }}
                />
              }}
            />
            <label
              className="form-check-label"
              htmlFor={`${name}-${option.value}`}
            >
              {option.label}
            </label>
          </div>
        ))}
        {errors[name] && (
          <div className="form-layout-message-error">{errors[name].message}</div>
        )}
      </div>
    </fieldset>
  );
};

export default FormCheckboxGroup;


export const FormCheckbox = ({
  name,
  label,
  hideLabel,
  control,
  className,
  labelClassName = 'color-black',
  wrapperClassName='',
  trigger,
  readOnly = false,
  disabled = false,
  required = false,
  handleOnclick = () => { }
}) => {
  const { errors } = useFormState({ control });

  return (
    <div className={`form-layout-input ${wrapperClassName}`}>
      <ul className="form-group-options">
        <li className={`${className || "m-0 pl-4"}`} key={name}>
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <input
                id={`steptable_${name}_checkbox`}
                type="checkbox"
                data-testid={`steptable_${name}_checkbox`}
                name={name}
                checked={!!field.value}
                readOnly={readOnly}
                disabled={disabled}
                onChange={e => {
                  field.onChange(e.target.checked)
                  if (trigger) {
                    trigger(name);
                  }
                }}
                onClick={handleOnclick}
              />
            )}
          />
          {required && (
            <span className="form-layout-required" aria-label="required">*</span>
          )}
          <label
            htmlFor={`steptable_${name}_checkbox`}
            className={`${labelClassName} ${hideLabel ? 'sr-only' : ''}`}
          >
            {label}
          </label>
        </li>
      </ul>
      {errors[name] && (
        <FormErrorMessage message={errors[name].message} className="mt-n2 mb-3" />
      )}
    </div>
  );
};